import { waitingForFile } from 'legacy/lut/classes/helpers/partner360/CommitmentHelper'
import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  generatePartnerPlanViaService,
  generatePdfPartnerPlanViaAppDes,
} from 'legacy/lut/classes/services/partner360/ExportCommitmentService'

import { CrudStore } from 'core/types/crudStore'

interface IGenerateProcess {
  partnerId: string
  fyear: number
  programType: ProgramTypes
  generatePDFOnBackend: boolean
  setProgressPercentage: (value: number) => void
  partnerInfoEntryId?: number
}

export const generateProcess = async ({
  partnerId,
  programType,
  fyear,
  generatePDFOnBackend,
  setProgressPercentage,
  partnerInfoEntryId,
}: IGenerateProcess) => {
  if (generatePDFOnBackend) {
    return generatePartnerPlanViaService({
      pid: partnerId,
      fYear: fyear,
      programType,
      exportFormat: 'PDF',
      openResultInNewTab: false,
    })
  }

  const crudExport = CrudStore.get(CrudStoreItemPartner360.JBPBPExportFiles, 'FileExport')
  const exportedFileFieldSuffix = programType ? programType.replaceAll(' ', '') : ''
  await crudExport.update({ formId: '621', code: 'JBPBasicInformation' }, [
    {
      EntryId: partnerInfoEntryId,
      [`ExportedFile${exportedFileFieldSuffix}`]: '',
    },
  ])

  await generatePdfPartnerPlanViaAppDes({
    pid: partnerId,
    fYear: fyear,
    programType,
    preventDownload: true,
  })
  const fileCreated = await waitingForFile(
    partnerId || '',
    fyear,
    programType,
    setProgressPercentage
  )
  return fileCreated
}
